import React from "react";

type Props = {
  children: React.ReactNode;
};

export const Grid = React.forwardRef<HTMLDivElement, Props & React.ComponentPropsWithRef<"div">>((props, ref) => {
  const { children, ...rest } = props;

  return (
    <div ref={ref} tw="w-full shrink-0 grid grid-cols-2 lg:grid-cols-12" {...rest}>
      {children}
    </div>
  );
});
